import React from "react";
import { Upload, message } from "antd";
import { InboxOutlined } from "@ant-design/icons";

const { Dragger } = Upload;

const UploadComponent = ({style,fileList,onRemove,customRequest,onDrop,onChange}) => {
  const props = {
    name: "file",
    multiple: true,
    // action: "https://your-upload-url.com", // Replace with your upload URL
    // onChange(info) {
    //   const { status } = info.file;
    //   if (status === "done") {
    //     message.success(`${info.file.name} file uploaded successfully.`);
    //   } else if (status === "error") {
    //     message.error(`${info.file.name} file upload failed.`);
    //   }
    // },
    // onDrop(e) {
    //   console.log("Dropped files", e.dataTransfer.files);
    // },
  };

  return ( 
    <Dragger fileList={fileList} onRemove={onRemove} onChange={onChange} onDrop={onDrop} customRequest={customRequest} style={style?style:{}} {...props}>
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">Click or drag file to this area to upload</p>
    </Dragger>
  );
};

export default UploadComponent;
